import React, { useState, useEffect } from "react";

export default function Termsandcondition() {
  const [isLoading, setIsLoading] = useState(true);
  const [logo, setlogo] = useState();
  const [id, setid] = useState();
  const [host, sethost] = useState();
  const [logourl, setlogourl] = useState();
  const [webSiteName, setwebSiteName] = useState();
  useEffect(() => {
    getbasicinfo();
    setIsLoading(false);
  }, []); // Empty dependency array ensures the effect runs once after initial render
  const getbasicinfo = async () => {
    const hostURL = window.location.origin;
    const urlWithoutProtocol = hostURL.replace(/^https?:\/\//, "");
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}get-basic-info`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      hostname: urlWithoutProtocol,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      // console.warn(data.message.url);

      if (data.status_code) {
        setlogo(data.message.logo);
        setlogourl(data.message.url + data.message.logo);
        setid(data.message.id);
        sethost(data.message.domain);
        setwebSiteName(data.message.webSiteName);

        localStorage.setItem("a_id", data.message.id);
        localStorage.setItem("webSiteName", data.message.webSiteName);
        localStorage.setItem("domain", urlWithoutProtocol);
      } else {
        localStorage.removeItem("a_id");
        localStorage.removeItem("domain");
        localStorage.removeItem("webSiteName");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <>
      {isLoading && (
        <div className="spinner-wrapper">
          <div className="loadernew2"></div>
        </div>
      )}

      {!isLoading && (
        <section id="Help" className="margin-bottom-88">
          {/* Your iframe code here */}
          <div className="margin-bottom-88 mb-0">
            <div className="pb-4">
              <iframe
                src={`https://khelobabaji.com/api/pages/other.php?id=${id}`}
                style={{ width: "100%", height: "100vh" }}
              />
            </div>
          </div>
          {/* Rest of your content */}
        </section>
      )}
    </>
  );
}
